import { useMutation, useQueryClient } from "@tanstack/react-query";

import { type GetStageResponse, setStageValue } from "@/adapters/api";
import { invalidateStageTree, stageKeys } from "../utils/query-keys.ts";
import { useStagesLockedGuard } from "./use-stages-locked-guard.ts";

export function useSetStageValue(constructionId: string | undefined) {
	const queryClient = useQueryClient();
	const guardLocked = useStagesLockedGuard(constructionId);

	return useMutation({
		mutationFn: ({
			stageId,
			valueCents,
		}: {
			stageId: string;
			valueCents: number | null;
		}) => {
			if (!constructionId) throw new Error("missing construction");
			return setStageValue(constructionId, stageId, valueCents);
		},
		onSuccess: (result) => {
			queryClient.setQueryData<GetStageResponse>(
				stageKeys.detail(constructionId, result.stage_id),
				(old) =>
					old && {
						...old,
						stage: {
							...old.stage,
							value_cents: result.value_cents ?? undefined,
						},
					},
			);
			return invalidateStageTree(queryClient, constructionId);
		},
		onError: guardLocked,
	});
}
